/**
 * 定制化数据 相关菜单配置
 *
 */

import { lazyLoad } from "@/utils/lazyLoad";
const customizedDataRoute = [
  {
    // component: Layout,
    component: lazyLoad,
    path: "/customizedData",
    name: "CustomizedData",
    meta: {
      title: "定制化数据",
      icon: "icon-customized",
    },
    children: [
      {
        path: "/customized/export",
        name: "DataExport",
        component: () => import("../pages/customizedData/DataExport/index.vue"),
        meta: {
          title: "数据导出",
          keepAlive: true,
        },
      },
    ],
  },
];
export default customizedDataRoute;
